import React from 'react';
import { css } from 'linaria';
import { ChevronLeftIcon, ChevronRightIcon } from '@fronton/icons-react';
import { ShortArrowProps } from './short-arrow.types';

const iconStyle = css`
  path {
    stroke-width: 3px;
  }
`;

export const ShortArrow: React.FC<ShortArrowProps> = ({ direction = 'right' }) => (
  <>
    {direction === 'left' ? (
      <ChevronLeftIcon className={iconStyle} />
    ) : (
      <ChevronRightIcon className={iconStyle} />
    )}
  </>
);
